
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import WarehouseLocationModule from "@/store/modules/barcodeSystem/warehouseLocation";
import { WarehouseLocationResource } from "@/models/api/barcodeSystem/warehouseLocations/get";

const warehouseLocationModuleState = getModule(WarehouseLocationModule);

@Component({
  components: {
    Select
  }
})
export default class WarehouseLocationSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;

  @Prop({ default: false })
  excludeSystemLocations: boolean;

  @Prop({ default: false })
  includeInactive: boolean;

  @Prop()
  type: string;

  @Prop()
  currentFacilityCode: string;

  @Prop({ default: false })
  typeAhead: boolean;

  localWarehouseLocations: WarehouseLocationResource[] = null;
  loading: boolean = false;



  async created() {
    if(this.multiple || !this.typeAhead)
    {
      this.loadWarehouseLocations();
    } 
    else
    {
      this.loadSelectedWarehouseLocation();
    }
  }

  loadWarehouseLocations()
  {
    this.loading = true;
    warehouseLocationModuleState.getWarehouseLocations(this.currentFacilityCode, !this.excludeSystemLocations)
      .then(response => this.localWarehouseLocations = response.data)
      .finally(() => {
        this.loading = false;
      });
  }

  loadSelectedWarehouseLocation()
  {
    if(this.localValue != null)
    {
      this.loading = true;
      warehouseLocationModuleState.getWarehouseLocation(this.localValue)
      .then(response => {
        if(response.data) {
          if(this.localWarehouseLocations == null)
            this.localWarehouseLocations = [];

          if(!this.localWarehouseLocations.some(x => x.id === response.data.id)) {
            this.localWarehouseLocations.push(response.data);
          }
        }
      })
      .finally(() => {
        this.loading = false;
      });
    }
  }

  get locations() {
    if(this.localWarehouseLocations != null)
    {
      if(this.currentFacilityCode)
        return this.localWarehouseLocations.filter(x => x.facilityCode == this.currentFacilityCode || x.facilityCode == null).map(x => ({ label: `${x.description} [${x.code}]`, value: x.id }));
      else
        return this.localWarehouseLocations.map(x => ({ label: `${x.description} [${x.code}]`, value: x.id }));
    }
    return [];
  }

  @Watch('currentFacilityCode')
  onCurrentFacilityCodeChanged(val: string, oldVal: string)
  {
    if(val != oldVal)
    {
      this.localValue = null;
      this.localWarehouseLocations = null;
      
      if(this.multiple || !this.typeAhead)
      {
        this.loadWarehouseLocations();
      }
    }
  }

  async search(value, loading) {
    if (loading) loading(true);

    if (!value || value == "") {
      this.localWarehouseLocations = [];
      return;
    }

    warehouseLocationModuleState
      .searchWarehouseLocationsTypeAhead({
        typeAheadValue: value,
        excludeSystemLocations: this.excludeSystemLocations,
        includeInactive: this.includeInactive,
        facilityCode: this.currentFacilityCode
      })
      .then(response => {
        this.localWarehouseLocations = response.data;
      })
      .catch(error => {})
      .finally(() => {
        if (loading) loading(false);
      });
  }
}
